/*
 * Fitgard product gallery — thumbs + main + click-to-open lightbox modal.
 * Re-init safe (shopify:section:load).
 */
(function () {
  function init(root) {
    if (!root || root.dataset.init === '1') return;
    if (typeof Swiper === 'undefined') { setTimeout(function () { init(root); }, 120); return; }
    root.dataset.init = '1';

    var thumbsEl = root.querySelector('.fitgard-product-gallery__thumbs');
    var mainEl = root.querySelector('.fitgard-product-gallery__viewer');
    if (!mainEl) return;

    var slides = mainEl.querySelectorAll('.swiper-slide').length;

    var thumbsSwiper = thumbsEl ? new Swiper(thumbsEl, {
      direction: window.matchMedia('(min-width: 750px)').matches ? 'vertical' : 'horizontal',
      slidesPerView: 'auto',
      spaceBetween: 10,
      freeMode: true,
      watchSlidesProgress: true,
      breakpoints: {
        750: { direction: 'vertical' }
      }
    }) : null;

    var prevHalf = root.querySelector('.fitgard-product-gallery__half--prev');
    var nextHalf = root.querySelector('.fitgard-product-gallery__half--next');
    var pagEl = root.querySelector('.fitgard-product-gallery__pagination');

    var mainSwiper = new Swiper(mainEl, {
      slidesPerView: 1,
      spaceBetween: 0,
      speed: 400,
      loop: slides > 1,
      thumbs: thumbsSwiper ? { swiper: thumbsSwiper } : undefined,
      keyboard: { enabled: true },
      pagination: pagEl ? { el: pagEl, clickable: true, type: 'bullets' } : false,
      autoHeight: true,
    });

    if (prevHalf) prevHalf.addEventListener('click', function () { mainSwiper.slidePrev(); });
    if (nextHalf) nextHalf.addEventListener('click', function () { mainSwiper.slideNext(); });

    root.querySelectorAll('.fitgard-product-gallery__thumb').forEach(function (t, i) {
      t.addEventListener('click', function () {
        mainSwiper.slideToLoop ? mainSwiper.slideToLoop(i) : mainSwiper.slideTo(i);
      });
    });

    // ---- Lightbox ----
    var lightbox = root.querySelector('[data-lightbox]');
    var openBtn = root.querySelector('[data-lightbox-open]');
    var closeBtn = root.querySelector('[data-lightbox-close]');
    var lbViewer = root.querySelector('[data-lightbox-swiper]');
    var lbPrev = root.querySelector('[data-lightbox-prev]');
    var lbNext = root.querySelector('[data-lightbox-next]');
    var lbCurrent = root.querySelector('[data-lightbox-current]');
    var lbSwiper = null;

    function ensureLightboxSwiper() {
      if (lbSwiper) return lbSwiper;
      var lbSlides = lbViewer.querySelectorAll('.swiper-slide').length;
      lbSwiper = new Swiper(lbViewer, {
        slidesPerView: 1,
        spaceBetween: 0,
        speed: 350,
        loop: lbSlides > 1,
        keyboard: { enabled: true },
        navigation: (lbPrev && lbNext) ? { prevEl: lbPrev, nextEl: lbNext } : false,
        on: {
          slideChange: function () {
            if (lbCurrent) lbCurrent.textContent = (this.realIndex + 1);
          }
        }
      });
      return lbSwiper;
    }

    function openLightbox() {
      lightbox.hidden = false;
      document.body.style.overflow = 'hidden';
      requestAnimationFrame(function () {
        lightbox.classList.add('is-open');
        var s = ensureLightboxSwiper();
        // Sync to the current main slide
        var idx = mainSwiper.realIndex || 0;
        if (s.slideToLoop) s.slideToLoop(idx, 0); else s.slideTo(idx, 0);
        if (lbCurrent) lbCurrent.textContent = (idx + 1);
        s.update();
      });
    }
    function closeLightbox() {
      lightbox.classList.remove('is-open');
      document.body.style.overflow = '';
      setTimeout(function () { lightbox.hidden = true; }, 200);
    }

    if (openBtn) openBtn.addEventListener('click', openLightbox);
    if (closeBtn) closeBtn.addEventListener('click', closeLightbox);
    // Click outside slide closes
    lightbox.addEventListener('click', function (e) {
      if (e.target === lightbox) closeLightbox();
    });
    // ESC closes
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !lightbox.hidden) closeLightbox();
    });
  }

  function initAll() {
    document.querySelectorAll('.fitgard-product-gallery').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', function () {
    document.querySelectorAll('.fitgard-product-gallery').forEach(function (el) {
      el.removeAttribute('data-init');
      init(el);
    });
  });
})();